import script from "./BrandSelector.vue?vue&type=script&lang=js"
export * from "./BrandSelector.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__